// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ArrowUpOutlinedSvg from "@ant-design/icons-svg/es/asn/ArrowUpOutlined";
import AntdIcon from '../components/AntdIcon';

var ArrowUpOutlined = function ArrowUpOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ArrowUpOutlinedSvg
  }));
};

ArrowUpOutlined.displayName = 'ArrowUpOutlined';
export default React.forwardRef(ArrowUpOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ArrowUpOutlined.js
// module id = 599
// module chunks = 0